import { NestedGame } from "@/types/serializers"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import GameItem from "../GameItem"

const GamesList = ({ games }: { games: NestedGame[] }) => {
  return games && games.length > 0 ? (
    <ul
      role="list"
      className="divide-y divide-gray-200 border-b border-gray-200"
    >
      {games.map((game) => (
        <GameItem key={game.id} {...game} />
      ))}
    </ul>
  ) : (
    <div className="padding mx-auto flex max-w-xs flex-col items-center justify-center py-10">
      <div className="flex items-center justify-center rounded-xl bg-gray-200 p-3">
        <MagnifyingGlassIcon className="h-6 w-6 text-gray-500" />
      </div>
      <h3 className="mt-4 text-center text-base leading-6 font-semibold text-gray-900">
        This player has no games.
      </h3>
    </div>
  )
}

export default GamesList
